import { DropdownMenu } from "@radix-ui/react-dropdown-menu";

import RenderIf from "common/components/RenderIf";
import { DropdownMenuTrigger } from "common/components/ui/DropdownMenu";
import FilterButton from "common/components/ui/FilterButton";

import { PROFILE_SEARCH_OPTIONS } from "../../../../../../../constants";
import useSearchOptions from "../../../../../../../datahooks/useSearchOptions";
import Followers from "../Options/Followers";
import GenericOptions from "../Options/GenericOptions";
import Languages from "../Options/Languages";
import useSearchParams from "../useSearchParams";

import type { JSX, ReactNode } from "react";

export default function SearchParamSelect({
  optionsKey,
}: {
  optionsKey: keyof typeof PROFILE_SEARCH_OPTIONS;
}) {
  // this helps load suggestions earlier
  useSearchOptions();
  const { appliedSearchParamValues } = useSearchParams(optionsKey);
  const { icon: Icon, label } = PROFILE_SEARCH_OPTIONS[optionsKey];

  let content: JSX.Element;
  if (optionsKey === "followers_of") {
    content = <Followers optionsKey={optionsKey} />;
  } else if (optionsKey === "languages") {
    content = <Languages optionsKey={optionsKey} />;
  } else {
    content = <GenericOptions optionsKey={optionsKey} />;
  }

  const isEnabled = !!appliedSearchParamValues.length;
  const firstSelection = appliedSearchParamValues[0];

  let triggerContent: ReactNode = label;

  if (
    optionsKey === "followers_of" &&
    firstSelection &&
    "full_name" in firstSelection
  ) {
    triggerContent = (
      <span className="max-w-32 truncate">{firstSelection.full_name}</span>
    );
  }

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <FilterButton
          size="sm"
          leftIcon={<Icon weight="fill" />}
          rightIcon={
            <RenderIf condition={isEnabled}>
              <span className="flex size-4 shrink-0 items-center text-button-xs justify-center rounded-full bg-black-950 text-white">
                {appliedSearchParamValues.length}
              </span>
            </RenderIf>
          }
        >
          {triggerContent}
        </FilterButton>
      </DropdownMenuTrigger>
      {content}
    </DropdownMenu>
  );
}
